import { Box } from "@mui/material";
import { useState } from "react";
import OutlinedButton from "../../../../components/buttons/OutlinedButton";
import CustomToolTip from "../../../../components/CustomTooltip";
import { icons } from "../icons/iconExport";
import LabelsDropdown from "./LabelsDropDown/LabelsDropdown";
export default function EditLabelsButton({
  checkedEntities,
  showLabel = true,
  disabled = false,
}) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  return (
    <Box>
      <CustomToolTip title={!showLabel ? "Add a label" : ""} placement="top">
        <OutlinedButton
          onClick={(event) => {
            setMenuAnchorEl(event.currentTarget);
          }}
          icon={icons.LabelOutlineIcon}
          size="small"
          buttonStyle="outlined"
          color="inherit"
          disabled={checkedEntities.length === 0 || disabled}
        >
          {showLabel ? "Labels" : ""}
        </OutlinedButton>
      </CustomToolTip>
      {menuAnchorEl && (
        <LabelsDropdown
          selectedEntities={checkedEntities}
          menuAnchorEl={menuAnchorEl}
          setMenuAnchorEl={setMenuAnchorEl}
        />
      )}
    </Box>
  );
}
